import { useFormContext } from 'react-hook-form';
import { TagsFormBody } from 'src/components/TagsFormBody';
import { useUserCanUpdateSaleTags } from 'src/hooks/useUserHasSalePermissions';
import { posChangedField } from 'src/utils/posFieldUtils';
import {
  ActionOutboxEntityType,
  Sale,
  SaleInput,
  Tag,
} from 'src/WebApiController';

export const TagsSection = ({
  sale,
  disabled,
}: {
  sale?: Sale | null;
  disabled?: boolean;
}) => {
  const { setValue, watch } = useFormContext<SaleInput>();
  const tags = watch('tags');

  const canEditTags = useUserCanUpdateSaleTags(sale, false /* isBulkEdit */);

  const onTagsUpdate = (tags: Tag[]) => {
    if (
      sale != null &&
      (sale.listingId != null || sale.originatedFromListingId != null) &&
      tags.some((t) => t.persistentTagId != null && t.sourceEntityId == null)
    ) {
      // Need to populate the sourceEntityId by looking at the listingId and originatedFromListingId
      const newTags = tags.filter(
        (t) => t.persistentTagId == null || t.sourceEntityId != null
      );

      const listingIds = Array.from(
        new Set([sale.listingId, sale.originatedFromListingId].filter(Boolean))
      );
      tags
        .filter((t) => t.persistentTagId != null && t.sourceEntityId == null)
        .forEach((t) => {
          listingIds.forEach((listingId) => {
            newTags.push({
              ...t,
              sourceEntityId: listingId,
            });
          });
        });

      setValue('tags', posChangedField(newTags), { shouldDirty: true });
    } else {
      setValue('tags', posChangedField(tags), { shouldDirty: true });
    }
  };

  return (
    <TagsFormBody
      canEditTags={canEditTags}
      tagsCurrentEntity={tags?.value ?? []}
      onTagsUpdate={onTagsUpdate}
      disabled={disabled}
      entityType={ActionOutboxEntityType.Sale}
    />
  );
};
